import React from 'react';
import { Link } from 'react-router-dom';
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import Star from "../UI/Favorites/Star"
import {useTranslation} from "react-i18next";

const card = (props) => {
    const {t} = useTranslation();

    let cssClasses = ['card'];
    let additionalClasses = (props.additionalClasses) ? props.additionalClasses : [];

    let cardTitle = (
        <h3 className='headline headline--card headline--c-white'>
            {props.cardTitle}&nbsp;&nbsp;<i className='fa fa-angle-right'></i>
        </h3>
    );
    if(props.cardLink){
        cardTitle = (
            <Link to={props.cardLink}>
                <h3 className='headline headline--card headline--c-white'>
                    {props.cardTitle}&nbsp;&nbsp;<i className='fa fa-angle-right'></i>
                </h3>
            </Link>
        )
    }

    let infoTooltip = ""
    let conditionToolTip = (props.data && props.data.subAccountDisplayMode.code === "A")
    if(conditionToolTip){
        infoTooltip =   <OverlayTrigger placement="top"
            overlay={<Tooltip id="tooltip-top">
                {t('account_ajustement.tooltip')}
            </Tooltip>}>
            <div className="btn-info-tooltip btn-info-tooltip--inline btn-info-tooltip--green"><i
                className="far fa-info-circle"></i>
                <div className="btn-info-tooltip__text">{t('account_ajustement.tooltipbtn')}&nbsp;?</div>
            </div>
        </OverlayTrigger>
    }

    return (
        <div className='col-xs-12 col-sm-6 col-md-6 col-lg-4 cards__col'>
            <div className={cssClasses.join(' ') + ' ' + additionalClasses.join(' ')}>
                <div  className={`card__header ${conditionToolTip ? 'card__header--tooltip' : ''}`}>
                    {cardTitle}
                    {(() => (props.showFavoriteButton) && <Star addRemoveFavorite={props.addRemoveFavorite} id={props.id} status={props.isFavorite} />)()}
                    {infoTooltip}
                </div>
                <div className='card__content'>
                    {props.children}
                </div>
            </div>
        </div>
    );

}

export default card
